import {useRuntimeConfig} from "nuxt/app";
import { RoutingDefinitions } from "@generator/types/RoutingDefinitions";

export const getPortalTypeDefinitionClient = (): RoutingDefinitions => {
	const runtimeConfig = useRuntimeConfig();
	const portalTypeStr = (runtimeConfig.public.portalType as string) || 'master';

	switch (portalTypeStr.toLowerCase()) {
	case 'distance_learning':
		return RoutingDefinitions.ATTENDANCE_ROUTE;
	default:
		return RoutingDefinitions.PORTAL_ROUTE;
	}

};
